import { render, staticRenderFns } from "./classDetails.vue?vue&type=template&id=4ea2aed6&"
import script from "./classDetails.vue?vue&type=script&lang=js&"
export * from "./classDetails.vue?vue&type=script&lang=js&"
import style0 from "./classDetails.vue?vue&type=style&index=0&id=4ea2aed6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports